export const ROLES_LIST = {
  SuperAdmin: 9999,
  Admin: 5150,
  Editor: 1984,
  User: 2001,
};
